import React from 'react'
import banner from "../../../images/students/question.webp"

export default function NotFree() {
    return (
        <div className='mb-[20px] sm:mb-[50px] xl:mb-[70px] p-[20px] md:p-[40px] relative z-0 w-full overflow-hidden text-center bg-[#FFD9D733]'>
            <img src={banner} alt='banner' loading='lazy' className='mx-auto object-cover w-[120px] md:w-[190px]' />
            <div className='mt-[14px] md:mt-[25px]'>
                <h3 className='text-[#101828] text-[24px] md:text-[54px] font-semibold'>Why not Free</h3>
                <p className='mt-[5px] md:mt-[10px] text-[#7D7F81] font-normal text-[14px] md:text-[25px]'>Because free never builds commitment. Free things get skipped. Free things get ignored.</p>
            </div>
            <div className='mt-[15px] md:mt-[35px]'>
                <p className='text-[#000000] font-semibold text-[18px] md:text-[30px]'>₹499 is not a fee. It’s a commitment to yourself.</p>
                <p className='mt-[6px] md:mt-[12px] text-[#4A5565] font-normal text-[12px] md:text-[24px]'>A psychological shift that says: “I am investing in my future.”</p>
            </div>
            <div className='mt-[20px] md:mt-[32px] bg-[#FF3B301A] w-full md:w-9/12 mx-auto rounded-[12px] md:rounded-[20px] p-[15px] md:p-[24px] text-[#FF3B30] text-center font-medium text-[16px] md:text-[24px]'>
                <p>We don’t want students selling their mother’s thali for education. We want education to uplift families — not burden them. </p>
            </div>
        </div>
    )
}
